import { render } from "./HeroAddAnnouncementModal.vue?vue&type=template&id=270e1654&scoped=true"
import script from "./HeroAddAnnouncementModal.vue?vue&type=script&lang=js"
export * from "./HeroAddAnnouncementModal.vue?vue&type=script&lang=js"

import "./HeroAddAnnouncementModal.vue?vue&type=style&index=0&id=270e1654&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270e1654"]])

export default __exports__